export const useIframeQuoteListener = () => {
	const router = useRouter();

	const handleMessage = (event) => {
		if (event.data?.type === "quote_page_symbol_click" && event.data?.symbol) {
			router.push(`/quote/${event.data.symbol}`);
		}
	};

	onMounted(() => {
		window.addEventListener("message", handleMessage);
	});

	onUnmounted(() => {
		window.removeEventListener("message", handleMessage);
	});
};
